<template>
    <div class="contactPopup" :class="{ 'contactPopupActive': isContactPopupActive }">
        <span class="error" :class="{ 'errorActive': errorMessage }">{{ errorMessage }}</span>
        <img 
            class="closeXIcon"
            @click="closePopup"
            :src="require(`@/assets/icons/form/closeX.svg`)" 
            alt=""
        >
        <div class="inputFields">
            <div class="shapeElement"></div>
            
            <!-- <img 
                class="signature"
                :src="require('@/assets/illustrations/drawings/signature.svg')" 
                alt=""
            > -->
            <div class="leftSide">
                <div style="text-align: center;">
                    <img 
                        class="logoImg"
                        :src="require('@/assets/logo/blackIconOnly.svg')" 
                        alt=""
                    >
                </div>
                <h2>Pärnu Betoonelement OÜ</h2>
                <p style="cursor: pointer; color: steelblue; margin-bottom: 10px; width: fit-content;" @click="openLink()">(Reg. <span style="text-decoration: underline">16329376</span>) (Kmkr. EE102675087)</p>
                <a href="mailto:info@parnubetoonelement.ee" style="text-decoration: none;">info@parnubetoonelement.ee</a>
                <p style="margin-top: 5px;">IBAN: EE21384239902112</p>
                <p style="margin-bottom: 10px; margin-top: 15px;"><img style="margin-top: 0px; margin-bottom: -10px; margin-left: -5px; margin-right: 3px;" class="inputIcon" :src="require('@/assets/icons/location-svgrepo-com.svg')"/><b style="font-size: 18px;">{{ $t("companyData.title") }}</b> <br><br> <span @click="openMaps('Pilli 6, Pärnu 80013, Pärnu maakond')" style="text-decoration: underline; cursor: pointer; text-align: start;">Pilli 6 Pärnu 80013 Pärnu maakond</span></p>
                <p><span style="text-decoration: underline; cursor: pointer; text-align: start;" @click="openMaps('Tehnika tn 1, Sauga, 85008 Pärnu maakond')">Tehnika tn 1 Sauga 85008 Pärnu maakond</span></p>
            </div>
            <div class="rightSide">
                <div class="singleLine">
                    <h2>Janno Tarvis</h2>
                    <p class="underTitle">{{ $t("companyData.ceo") }}</p>
                    <div class="iconLine">
                        <img class="dataIcon" :src="require('@/assets/icons/dark/phone.svg')"/>
                        <p>+372 58241908</p>
                    </div>
                    <div class="iconLine">
                        <img class="dataIcon" :src="require('@/assets/icons/dark/email.svg')"/>
                        <a style="text-decoration: underline;" href="mailto:janno@parnubetoonelement.ee">janno@parnubetoonelement.ee</a>
                    </div>
                </div>
                <div class="singleLine">
                    <h2>Toomas Lauter</h2>
                    <p class="underTitle">{{ $t("companyData.production") }}</p>
                    <div class="iconLine">
                        <img class="dataIcon" :src="require('@/assets/icons/dark/phone.svg')"/>
                        <p>+372 53493813</p>
                    </div>
                    <div class="iconLine">
                        <img class="dataIcon" :src="require('@/assets/icons/dark/email.svg')"/>
                        <a style="text-decoration: underline;" href="mailto:toomas@parnubetoonelement.ee">toomas@parnubetoonelement.ee</a>
                    </div>
                </div>
                <div class="singleLine">
                    <h2>Aleksandra Škatova</h2>
                    <p class="underTitle">{{ $t("companyData.budgeter") }}</p>
                    <div class="iconLine">
                        <img class="dataIcon" :src="require('@/assets/icons/dark/phone.svg')"/>
                        <p>+372 53668864</p>
                    </div>
                    <div class="iconLine">
                        <img class="dataIcon" :src="require('@/assets/icons/dark/email.svg')"/>
                        <a style="text-decoration: underline;" href="mailto:info@parnubetoonelement.ee">info@parnubetoonelement.ee</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="successMessage" v-if="inquirySent">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
            <p>{{ $t("form.confirmationText") }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'contactPopup',
    components: {
    },
    props: {
        isContactPopupActive: null
    },  
    data() {
        return {
            inquirySent: false,

            errorMessage: null,

            recaptchaDone: null,

            person: null,
            personError: false,

            business: null,
            businessError: false,

            email: null,
            emailError: false,

            phoneNr: null,
            phoneError: false,

            letter: null,
            letterError: false
        }
    },  
    methods: {
        openLink() {
            const url = `https://www.teatmik.ee/en/personlegal/16329376-P%C3%A4rnu-Betoonelement-O%C3%9C`;

            window.open(url, "_blank", "noopener,noreferrer");
        },  
        openMaps(address) {
            const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

            window.open(url, "_blank", "noopener,noreferrer");
        },  

        sendInquiry() {
            if(!this.person) {
                this.personError = true
                this.errorMessage = 'Nime, emaili ja täpsustava teksti sisestamine on kohustuslik!'
            }
            if(!this.email) {
                this.emailError = true
                this.errorMessage = 'Nime, emaili ja täpsustava teksti sisestamine on kohustuslik!'
            }
            if(!this.letter) {
                this.letterError = true
                this.errorMessage = 'Nime, emaili ja täpsustava teksti sisestamine on kohustuslik!'
            }
            if(!this.recaptchaDone) {
                this.errorMessage = 'Palun täitke reCAPTCHA kinnitus või proovige uuesti!'
            }
            if(!this.errorMessage) {
                fetch('https://parnubetoonelement.ee/mail', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "text": this.letter,
                        "name": this.person,
                        "company": this.business,
                        "phone": this.phoneNr,
                        "email": this.email
                    }),
                })
                .then((res) => {
                    if(res.ok) {
                        this.errorMessage = null
                        this.inquirySent = true
                        this.person = null
                        this.business = null
                        this.email = null
                        this.phoneNr = null
                        this.letter = null

                        setTimeout(() => {
                            this.closePopup()
                        }, 2000)
                    } else {
                        this.errorMessage = 'Midagi läks valesti, palun proovi uuesti!'
                    }
                })

            }
            if(this.errorMessage) {
                setTimeout(() => {
                    this.errorMessage = null
                }, 3000)
            }
        },

        closePopup() {
            this.inquirySent = false
            this.$emit('closePopup')
        }
    },
}
</script>
<style scoped>
.contactPopup {
    z-index: 100000;
    position: fixed;
    top: -2000px;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: 450px;
    padding-bottom: 15px;
    width: 750px;
    background: white;
    border-radius: 10px;
    -webkit-transition: .3s;
    transition: .3s;
    overflow: hidden;
}
.contactPopupActive {
    top: 0;
    -webkit-transition: .3s;
    transition: .3s;
}
.inputFields {
    width: 100%;
    padding-left: 0px;
    padding-right: 0px;
    margin: 0 auto;
    margin-top: 0px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}
.logoImg {
    width: 170px;
    margin-right: 30px;
}
.shapeElement {
    width: 30px;
    height: 200px;
    background-color: #EFF2F8 ;
    position: absolute;
    right: 40px;
    bottom: -70px;
    rotate: 45deg;
}
.signature {
    position: absolute;
    bottom: 10px;
    opacity: .5;
    left: -60px;
    rotate: -05deg;
    width: 450px;
}
.leftSide {
    width: 50%;
    text-align: left;
    background-color: #EFF2F8;
    padding: 25px 20px 100px 40px;
}
.rightSide {
    text-align: start;
    width: 50%;
    padding: 15px 40px 100px 40px;
}
.singleLine {
    margin-top: 10px;
    margin-bottom: 25px;
}
.underTitle {
    color: #8f9dbb;
    margin-bottom: 8px;
}
.leftSide h2 {
    margin: 0;
    margin-bottom: 10px;
    margin-top: 10px;
    font-size: 22px;
    color: rgb(40, 96, 143);
}
.leftSide p, .leftSide a {
    color: #8f9dbb;
    margin-bottom: 5px;
}
.iconLine {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 10px;
    color: #5f7091;
}
.iconLine a {
    color: #5f7091;
}
.iconLine img {
    margin-right: 10px;
}
.singleInput {
    position: relative;
    width: 45%;
    margin-right: 0px;
    margin-left: 0px;
    margin-top: 0px;
    margin-bottom: 15px;
}
.inputIcon {
    
    z-index: 20;
    width: 30px;
    opacity: 1;
}
input {
    position: relative;
    z-index: 10;
    height: 50px;
    width: 97%;
    text-indent: 40px;
    border-radius: 0px;
    border: none;
    border-bottom: 1px solid #4d455d7c;
    color: #4D455D;
}
textarea {
    height: 150px;
    margin-top: 10px;
    padding-top: 15px;
    padding-left: 4%;
    padding-right: 4%;
    width: 92%;
    border-radius: 10px;
    border: 1px solid #4d455d7c;
}
input:focus {
    outline: none;
    border-bottom: 1px solid #4D455D;
    -webkit-transition: .2s;
    transition: .2s;
}
textarea:focus {
    outline: none;
    border: 1px solid #4D455D;
    -webkit-transition: .2s;
    transition: .2s;
}
textarea::-webkit-input-placeholder, input::-webkit-input-placeholder {
    font-size: 15px;
    color: #4D455D;
}
textarea::-moz-placeholder, input::-moz-placeholder {
    font-size: 15px;
    color: #4D455D;
}
textarea:-ms-input-placeholder, input:-ms-input-placeholder {
    font-size: 15px;
    color: #4D455D;
}
textarea::-webkit-input-placeholder {
    font-size: 15px;
    color: #4D455D;
}
textarea::-moz-placeholder {
    font-size: 15px;
    color: #4D455D;
}
textarea:-ms-input-placeholder {
    font-size: 15px;
    color: #4D455D;
}
textarea::-ms-input-placeholder {
    font-size: 15px;
    color: #4D455D;
}
textarea::placeholder {
    font-size: 15px;
    color: #4D455D;
}
textarea {
    width: 100%;
    resize: none;
    margin-bottom: 30px;
    color: #4D455D;
}
.inputError::-webkit-input-placeholder {
    color: #a11e34;
    -webkit-transition: .2s;
    transition: .2s;
}
.inputError::-moz-placeholder {
    color: #a11e34;
    -moz-transition: .2s;
    transition: .2s;
}
.inputError:-ms-input-placeholder {
    color: #a11e34;
    -ms-transition: .2s;
    transition: .2s;
}
.inputError::-ms-input-placeholder {
    color: #a11e34;
    -ms-transition: .2s;
    transition: .2s;
}
.inputError::placeholder {
    color: #a11e34;
    -webkit-transition: .2s;
    transition: .2s;
}
.inputError {
    border-bottom: 1px solid #E76161;
    -webkit-transition: .2s;
    transition: .2s;
}
.error {
    position: absolute;
    z-index: 101;
    top: -100px;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding-top: 8px;
    padding-bottom: 8px;
    border-radius: 0px 0px 10px 10px;
    width: 80%;
    background: #E76161;
    color: white;
    font-size: 18px;
    -webkit-transition: .2s;
    transition: .2s;
}
.errorActive {
    top: 0px;
    left: 0;
    -webkit-transition: .2s;
    transition: .2s;
}
.successMessage {
    height: 350px;
    position: relative;
    z-index: 100;
}
.successMessage p {
    position: absolute;
    left: 0;
    right: 0;
    top: 300px;
    padding-left: 25px;
    padding-right: 25px;
    margin: auto;
    z-index: 1000;
    margin-top: 0px;
    font-size: 28px;
    color: #64C3A2;
}
.btnContainer {
    margin-top: -20px;
    padding-left: 75px;
    padding-right: 75px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}
.button {
    border: 1px solid #4D455D;
    background: #4D455D;
    color: white;
    border-radius: 10px;
    padding-left: 40px;
    padding-right: 40px;
    padding-top: 8px;
    padding-bottom: 8px;
    height: 43px;
    font-size: 20px;
}
.button:hover {
    cursor: pointer;
    opacity: .9;
}
.closeXIcon {
    position: absolute;
    z-index: 1000;
    right: 27px;
    top: 23px;
    width: 18px;
    cursor: pointer;
}

.checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #64C3A2;
    fill: none;
    -webkit-animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
            animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
    position: absolute;
    left: 0;
    right: 0;
    top: 75px;
    margin: auto;
    width: 175px;
    height: 175px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #64C3A2;
    stroke-miterlimit: 10;
    -webkit-box-shadow: inset 0px 0px 0px #64C3A2;
            box-shadow: inset 0px 0px 0px #64C3A2;
    -webkit-animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
            animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}

.checkmark__check {
    -webkit-transform-origin: 50% 50%;
        -ms-transform-origin: 50% 50%;
            transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    -webkit-animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
            animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}
@-webkit-keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}
@-webkit-keyframes scale {
    0%, 100% {
        -webkit-transform: none;
                transform: none;
    }
    50% {
        -webkit-transform: scale3d(1.1, 1.1, 1);
                transform: scale3d(1.1, 1.1, 1);
    }
}
@keyframes scale {
    0%, 100% {
        -webkit-transform: none;
                transform: none;
    }
    50% {
        -webkit-transform: scale3d(1.1, 1.1, 1);
                transform: scale3d(1.1, 1.1, 1);
    }
}
@-webkit-keyframes fill {
    100% {
        -webkit-box-shadow: inset 0px 0px 0px 63px #ffffff;
                box-shadow: inset 0px 0px 0px 63px #ffffff;
    }
}
@keyframes fill {
    100% {
        -webkit-box-shadow: inset 0px 0px 0px 63px #ffffff;
                box-shadow: inset 0px 0px 0px 63px #ffffff;
    }
}
@media (max-width: 800px) {
    .contactPopup {
        width: 90%;
        height: -webkit-fit-content;
        height: -moz-fit-content;
        height: fit-content;
    }
}
@media (max-width: 750px) {
    .leftSide, .rightSide{
        width: 100%;
        text-align: center;
        padding-bottom: 20px;
        padding-left: 25px;
        padding-right: 25px;
    }
    .iconLine {
        margin: 0 auto;
        text-align: center;
        width: -webkit-fit-content;
        width: -moz-fit-content;
        width: fit-content;
    }
    .singleLine h2 {
        font-size: 18px;
    }
    .logoImg {
        width: 150px;
        margin-right: 0;
    }
}

@media (max-width: 450px) {
    .contactPopup {
        overflow-y: scroll;
    }
}
</style>